import { useMutation } from '@tanstack/react-query';
import { handleRoleChangeSeatManagement } from '@/apis/handleRoleChangeSeatManagement';
import { useToast } from '@/hooks/useToast';

export const useRoleChangeSeatManagement = () => {
  const toast = useToast();

  return useMutation({
    mutationFn: handleRoleChangeSeatManagement,
    onSuccess: (data) => {
      if (data.success) {
        toast({
          title: 'Success',
          description: data.message,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
      // COMMENTED OUT: Payment redirect logic for role changes
      // } else if (data.requiresPayment && data.checkoutUrl) {
      //   // Redirect to Stripe checkout for payment
      //   window.location.href = data.checkoutUrl;
      // }
    },
    onError: (error: Error) => {
      toast({
        title: 'Error',
        description: error.message || 'Failed to change user role',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    },
  });
};
